// extracted by mini-css-extract-plugin
export var productHighlight = "ProductGrid-module--productHighlight--DnQUJ";